import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c42e1f5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6c42e1f5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42e1f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c42e1f5')) {
      api.createRecord('6c42e1f5', component.options)
    } else {
      api.reload('6c42e1f5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c42e1f5&scoped=true", function () {
      api.rerender('6c42e1f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sectionHeader/index.vue"
export default component.exports